import { createSlice } from '@reduxjs/toolkit'
import { UiState } from '@typings/store/uiState.types'

const initialState: UiState = {
  userClosedOnboardingModal: false,
  userClosedEndRentalModal: false,
  userClosedInfoModal: false,
  mobileMenuOpen: false,
}

export const uiStateSlice = createSlice({
  name: 'uiState',
  initialState,
  reducers: {
    toggleMobileMenu: (store) => {
      store.mobileMenuOpen = !store.mobileMenuOpen
    },
    closeOnboardingModal: (store) => {
      store.userClosedOnboardingModal = true
    },
    closeEndRentalModal: (store) => {
      store.userClosedEndRentalModal = true
    },
    closeInfoModal: (store) => {
      store.userClosedInfoModal = true
    },
  },
})

export const { toggleMobileMenu, closeOnboardingModal, closeEndRentalModal, closeInfoModal } = uiStateSlice.actions
export const uiStateReducer = uiStateSlice.reducer
